import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
import { IMAGES } from '../data/links';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number;
    let hideTimer: number;
    const cycle = (i: number, delay: number) => {
      showTimer = window.setTimeout(() => {
        setIndex(i);
        setOpen(true);
        hideTimer = window.setTimeout(() => {
          setOpen(false);
          cycle((i + 1) % buyers.length, 9000);
        }, 5000);
      }, delay);
    };
    cycle(0, 6000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:left-6 sm:right-auto sm:bottom-28" aria-live="polite" data-id="element-40" data-mp="165zde5uinbla">
      <AnimatePresence data-id="element-41" data-mp="115uxagxisivl">
        {open && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl border border-sand bg-paper p-3 pr-9 shadow-[0_16px_40px_-16px_rgba(10,51,40,0.45)] sm:w-[340px]" data-id="element-42" data-mp="1fvso74mu3moh">
            <img src={IMAGES.mainMockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-43" data-mp="x2y8g8hdzqj7" />
            <div className="min-w-0" data-id="element-44" data-mp="28kg74tk41zyv">
              <p className="truncate text-sm font-bold text-ink" data-id="element-45" data-mp="28jep254ogd7n">
                {buyer.name} <span className="font-medium text-muted" data-id="element-46" data-mp="23lwk0pts6i4x">· {buyer.country}</span>
              </p>
              <p className="text-[13px] leading-snug text-ink/80" data-id="element-47" data-mp="2ap32fekxwyda">
                just purchased the <strong className="text-forest" data-id="element-48" data-mp="2fne9xinriwsc">21-Day Practice Method™</strong>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-cta" data-id="element-49" data-mp="2kn0nxubf0h27">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-50" data-mp="2plkanwxu1wvm" />
                Verified · {buyer.minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:bg-sand hover:text-ink" data-id="element-51" data-mp="1rzwm1y7mciun">
              <XIcon className="h-4 w-4" data-id="element-52" data-mp="26oaqueolihdu" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}